export const ERROR_MSGS = {
  streamingLimitMessage: 'Streaming Limit Exceeded',
  donwloadLimitMessage: 'Download Limit Exceeded',
  donwloadAllLimitMessage:
    'You have exceeded the download limit ' +
    'for one or more assets. Please download assets individually.',
  donwloadDeniedDeviceAllMessage: 'Download denied on the device - Download All Failure',
  donwloadAsperaMessage: 'Please use Aspera for larger size files - Download All',
  defaultErrorMessage: 'An error occurred. Please try again later',
  shareDeliveryErrorMessage: 'Delivery is already shared with this user',
  expiredDelivery: 'Expired Delivery',
};
